<template>
  <div class="settlement-detail">
    <detail-head :data="headData"></detail-head>
    <detail-list
      :data="settlementData"
      :status="status"
      @calculate="handleCalculate"
      @refresh="fetch"
    ></detail-list>
  </div>
</template>

<script>
import DetailHead from './component/detail-head'
import DetailList from './component/detail-list'
import NP from 'number-precision'
import { currencyFormat } from '@/common/filters'
import { getWebToken } from '@/common/utils/common.js'
import { FILE_ACCESS_PRIVATE } from '@/common/constants'
import preview from '@/common/utils/preview'

export default {
  components: { DetailHead, DetailList },
  data() {
    return {
      headData: {
        status: '',
        buyerOrgName: '',
        settleOrderNo: '',
        gmtCreated: '',
        createUserId: '',
        createUserName: '',
        gmtConfirmed: '',
        confirmUserId: '',
        confirmUserName: '',
        weightDiff: '',
        totalQuantity: 0,
        totalWeight: 0,
        totalAmount: 0
      },
      settlementData: [],
      status: ''
    }
  },
  methods: {
    handleCalculate({ totalQuantity, totalWeight, totalAmount }) {
      this.headData.totalQuantity = totalQuantity
      this.headData.totalWeight = totalWeight
      this.headData.totalAmount = totalAmount
    },
    async fetch() {
      const request = { settleOrderId: this.$route.params.id }
      const { success, data } = await this.$post('settle.seller.querySettleOrderItems', { request })
      if (success && data) {
        Object.keys(this.headData).forEach(key => {
          this.headData[key] = data[0][key]
        })
        this.status = data[0].status
        const filterGroup = {}
        data[0].settleOrderItemVOList.forEach(ele => {
          //结算单可修改，用来区分，是修改还是确认
          ele.$disabled = true
          //结算单价
          ele.$settlePerAmount = `¥${NP.divide(ele.settlePerAmount, 100)}/${ele.chargeUnit}`
          ele.$settlePerAmountCopy = ele.$settlePerAmount
          //结算数量
          ele.$settleQuantity = `${ele.settleQuantity}件`
          ele.$settleQuantityCopy = ele.$settleQuantity
          //结算重量
          ele.$settleWeight = `${NP.divide(ele.settleWeight, 10000)}吨`
          ele.$settleWeightCopy = ele.$settleWeight
          //结算金额
          ele.$settleAmount = `¥${NP.divide(ele.settleAmount, 100)}`
          ele.$settleAmountCopy = ele.$settleAmount

          const { bizOrderNo } = ele
          if (filterGroup[bizOrderNo]) {
            filterGroup[bizOrderNo].list.push(ele)
          } else {
            const list = []
            list.push(ele)
            filterGroup[bizOrderNo] = {
              $totalQuantity: 0,
              $totalWeight: 0,
              $totalAmount: 0,
              list,
              ...ele
            }
          }
        })

        //结算单能否修改
        //待结算状态，结算金额等于0，没有sku修改记录，就不能修改结算单
        let skuCanModify = false
        if (data[0].status === 1) {
          skuCanModify = true
        } else {
          skuCanModify = false
        }

        const groupArray = []
        Object.keys(filterGroup).forEach(key => {
          filterGroup[key].$skuCanModify = skuCanModify
          groupArray.push(filterGroup[key])
        })
        this.settlementData = groupArray
      }
    },
    checkUpload() {
      if (this.status === 2) {
        if (this.loopCount < 3) {
          this.loopCount = this.loopCount + 1
          setTimeout(() => {
            this.fetch()
          }, 500)
        } else {
          this.loopUpdate = false
          this.loopCount = 0
        }
      } else {
        this.loopUpdate = false
        this.loopCount = 0
      }
    }
  },
  mounted() {
    this.fetch()
  },
  beforeDestroy() {
    preview.previewDestroy()
  }
}
</script>
